import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const SelfServiceOriginationPointSelection = (props) => {
  const { selectedOriginationPoint, onBack, onNext, onValueChange } = props;

  const originationPoints = ['MACHINE_DRIVEN', 'LIVE_LINK'];

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the turn origination point</h4>
        <p>
          Do you want to simulate a self-serve transaction directly from the machine or from the
          live link?
        </p>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select where the turn should originate from</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-origination-point"
            options={originationPoints}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Origination Point" />}
            value={selectedOriginationPoint}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedOriginationPoint,
          })}
          disabled={!selectedOriginationPoint}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default SelfServiceOriginationPointSelection;
